import { useCallback } from 'react';
import { useSettings } from '@/entities/settings';

/**
 * Результат {@link useNavigationCollapse}.
 */
export type NavigationCollapse = {
  /** Меню навигации по атрибутам развёрнуто. */
  isNavigationOpen: boolean;
  /** Сохраняет новое состояние меню навигации. */
  setNavigationOpen: (isOpen: boolean) => void;
};

/**
 * Свёрнутость меню навигации по атрибутам.
 *
 * Свёрнутость — настройка пользователя: она хранится в настройках интерфейса рядом со
 * свёрнутостью блоков и порядком групп, поэтому переживает переход к другому диалогу и
 * следующий вход в систему. Хранится отклонение от умолчания: нет записи — меню развёрнуто.
 */
export const useNavigationCollapse = (): NavigationCollapse => {
  const { dialogsPage, setDialogsSettings } = useSettings();

  const setNavigationOpen = useCallback(
    (isOpen: boolean) => {
      setDialogsSettings({ attrNavCollapsed: !isOpen });
    },
    [setDialogsSettings],
  );

  return { isNavigationOpen: !dialogsPage.attrNavCollapsed, setNavigationOpen };
};
